module.exports = __webpack_public_path__ + "img/ai-1.e8ffa0a.png";